<template>
  <NuxtLink
    :to="link"
    class="flex cursor-pointer items-center gap-1.5 px-spacing_7 py-spacing_2 hover:bg-neutral-200"
    @click="$emit('select', q_key, value)"
  >
    <Image
      v-if="img && show_img"
      class="h-[42px] w-[42px] truncate rounded-r3 object-contain"
      img-classes="!object-contain"
      :src="img"
    />
    <Button
      class="menu-item"
      :label
      :suffix_icon="children?.length ? 'ic-arrow-right' : undefined"
      :c_style="{
        type: 'text',
        style: 'B',
      }"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
import Button from "~/components/common/Atom/Button.vue";
import Image from "~/components/common/Atom/Image.vue";
import { NavItemProps } from "~/types/schemas/informative/Molecule/NavItem";

defineEmits<{
  select: [key: string, value: string];
}>();

defineProps<NavItemProps>();
</script>

<style>
.menu-item {
  width: 100%;
  justify-content: start;
  .btn-label {
    text-align: start;
    @apply max-w-full truncate text-ellipsis;
  }
}
</style>
